import { Button } from '@winnin/winnin_ui.components.button'
import { Checkbox } from '@winnin/winnin_ui.components.checkbox'
import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'
import { Loading } from '@winnin/winnin_ui.components.loading'
import { Modal } from '@winnin/winnin_ui.components.modal'
import { Title } from '@winnin/winnin_ui.components.title'

import { useTranslate } from 'lib/tolgee'
import { MODAL_STYLE } from 'modules/dashboard/common/dashboard.consts'
import { translations as translationsCommon } from 'modules/dashboard/common/dashboard.i18n'
import { TOLGEE_GLOBALS } from 'utils'

import { translations } from './create-dashboard-folder-modal.i18n'
import type { TCreateDashboardFolderModalView } from './create-dashboard-folder-modal.types'
import './create-dashboard-folder-modal.styles.scss'

export const CreateDashboardFolderModalView = ({
  isOpen,
  dashboardList,
  handleInputChange,
  inputValue,
  handleSelectDashboard,
  handleCreateDashboardFolder,
  isSubmitDisabled,
  handleCloseModal,
  hasMore,
  sentryRef,
}: TCreateDashboardFolderModalView) => {
  const t = useTranslate()
  return (
    <Modal style={MODAL_STYLE} isOpen={isOpen} onRequestClose={handleCloseModal}>
      <div className="CreateDashboardFolderModal">
        <Title tag="h3">{t(translationsCommon.createDashboardFolder)}</Title>
        <InputWithLabel
          label={t(translationsCommon.folderName)}
          placeholder={t(translationsCommon.folderName)}
          onChange={handleInputChange}
          value={inputValue}
          name="folderName"
          maxLength={50}
        />
        <p className="listLabel">{t(translations.description)}</p>
        <ul className="dashboardList">
          {dashboardList.map(item => {
            return (
              <li key={item.id}>
                <Checkbox handleClick={() => handleSelectDashboard(item.id)} isActive={item.isSelected}>
                  <p className="dashboardName">{item.name}</p>
                  <span className="dashboardInfo">{item.subtitle}</span>
                </Checkbox>
              </li>
            )
          })}
          {hasMore && (
            <div ref={sentryRef}>
              <Loading />
            </div>
          )}
        </ul>
        <div className="buttonsSection">
          <Button appearance="link" onClick={handleCloseModal}>
            {t(TOLGEE_GLOBALS.cancel)}
          </Button>
          <Button onClick={handleCreateDashboardFolder} disabled={isSubmitDisabled}>
            {t(TOLGEE_GLOBALS.done)}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
